<template>
  <div class="free-shipping">
    <p v-if="amountUntilFreeShipping">
      You're {{ amountUntilFreeShipping }} away from free shipping
    </p>
    <p v-else>FREE STANDARD SHIPPING</p>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { shippingRules } from "@/config.js";

export default {
  name: "FreeShippingProgress",
  props: {
    subtotal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapState("app", ["userCountry"]),
    freeShippingOnAllOrders() {
      if (!this.currencyCode) {
        return;
      }

      const rules = shippingRules[this.currencyCode];
      return this.userCountry === rules.freeForCountry;
    },
    amountUntilFreeShipping() {
      if (this.freeShippingOnAllOrders) {
        return;
      }

      const rules = shippingRules[this.currencyCode];
      const difference = rules.freeAboveAmount.amount - this.subtotal.amount;

      if (difference <= 0) {
        return;
      }

      return this.$filters.toCurrency(
        difference,
        this.subtotal.currencyCode,
        0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.free-shipping {
  text-align: center;
  padding: 20px;
  background-color: $color-grey-light;
  margin: -20px -20px 20px;

  p {
    @include t__utility-label-30;
  }
}
</style>
